import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl/dist';

// Components

import ImmigrationStatusTooltip from '../tooltips/ImmigrationStatusTooltip';



const Page1_01 = props => {

    const {
        environment: {
            exchangeName,
            isState
        },
    } = props;

    /**
     * Until backend/api for explainers have been completed,
     * (this had also been pushed out of 21.9 and 22.1)
     * this call will be commented out as to not disrupt
     * end-to-end testing.
     */
    // const { TOP_OF_PAGE } = useExplainer(
    //     { ...{ 
    //         actions: props.actions, // waiting for fetchExplainerData async action creator
    //         explainerData, // the source is environment
    //         location: 'SSAP',
    //         pageName: adjustedFlow[page].page.pageName
    //     } }
    // );

    const items = [
        'names',
        'addresses',
        'ssn',
        'birth_date',
        'documents'
    ];

    const getList = () => {
        return items.map(itemName => {
            const getLiContent = () => {
                switch (itemName) {
                    case 'documents': {
                        return <Fragment>
                            <FormattedMessage
                                id={`ssap.start.get_ready.item.${itemName}`}
                            />
                            <ImmigrationStatusTooltip
                                { ...{
                                    isState
                                } }
                            />
                        </Fragment>;
                    }
                    default:
                        return <FormattedMessage id={`ssap.start.get_ready.item.${itemName}`}/>;
                }
            };
            
            return (
                <li key={itemName}>
                    { getLiContent() }
                </li>
            );
        });
    };

    return (
        <Fragment>
            <div id="saGetReady">
                <div className="subsection">
                    {/* { TOP_OF_PAGE } */}{/* see comment above */}
                    <div className="usa-alert usa-alert--info gi-alert gi-alert__info">
                        <div className="usa-alert__body gi-alert__info__body">
                            <p className="usa-alert__text gi-alert__info__text">
                                <strong>
                                    <FormattedMessage
                                        id="ssap.start.get_ready.welcome_message"
                                        values={ { exchangeName } }
                                    />
                                </strong><br/>
                                <FormattedMessage id="ssap.start.get_ready.gather_info_notification"/>
                            </p>
                        </div>
                    </div>
                    <p>
                        <FormattedMessage
                            id="ssap.start.get_ready.asterisks_warning"
                            tagName='i'
                        />
                    </p>
                    <p>
                        <FormattedMessage id="ssap.start.get_ready.you_need"/>
                    </p>
                    <ul className="usa-list gi-list--ul">
                        { getList() }
                    </ul>
                </div>
            </div>
        </Fragment>
    );
};


const mapStateToProps = state => ({
    environment: state.common.environment
});

export default connect(mapStateToProps)(Page1_01);
